export default __webpack_public_path__ + "static/media/bg-cyber.37302f98.webp";